export default "__VITE_ASSET__4d2a31d7__"